import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useTranslation } from '../../../common/hooks/useTranslation';
import { usePokCore } from '../../../common/hooks/usePokCore';
import ConfirmationButton from '../../../app/components/ConfirmationButton';
import AlertModal from '../../../app/components/AlertModal';
import { responseErrors } from '../../../common/pokCore/validation/responseErrors';

interface EODRefreshErrorFromEodLinkProps {
  eodId: number;
  onRefresh: () => void;
}

export const EODRefreshErrorFromEodLink: React.FC<
  EODRefreshErrorFromEodLinkProps
> = props => {
  const pok = usePokCore();
  const [isLoading, setIsLoading] = React.useState(false);
  const [showInfo, setShowInfo] = React.useState(false);
  const [info, setInfo] = React.useState('');
  const [success, setSuccess] = React.useState(false);
  const { t, tk } = useTranslation('fvzLng');

  const refresh = () => {
    setIsLoading(true);
    pok.eodLogs
      .changeStatusExportedToEod(props.eodId)
      .then(() => {
        setIsLoading(false);
        setSuccess(true);
        setInfo(t(tk.eod.refreshErrorFromEodSuccess));
        setShowInfo(true);
      })
      .catch(async err => {
        const errors = await responseErrors(err);
        setInfo(errors?.[0]);
        setIsLoading(false);
        setSuccess(false);
        setShowInfo(true);
      });
  };

  return (
    <>
      <OverlayTrigger overlay={<Tooltip>{t(tk.button.refresh)}</Tooltip>}>
        <ConfirmationButton
          variant="outline-primary"
          className="px-2"
          onOK={() => refresh()}
          modalSize="lg"
          confirmation={t(tk.eod.confirmRefreshErrorFromEod)}
          isLoading={isLoading}
        >
          <Icon.ArrowClockwise size={16} />
        </ConfirmationButton>
      </OverlayTrigger>
      <AlertModal
        variant={success ? 'info' : 'danger'}
        buttonText={t(tk.button.close)}
        buttonVariant={'outline-success'}
        size="lg"
        show={showInfo}
        onHide={() => {
          setShowInfo(false);
          props.onRefresh();
        }}
      >
        {info}
      </AlertModal>
    </>
  );
};
